import { forwardRef } from 'react';

import { Dialog } from '@/components/atoms';
import { DialogTitleProps } from '@/components/atoms/Dialog/DialogTitle';
import { cn } from '@/lib/utils/tailwind';

type ModalTitleProps = DialogTitleProps;

const ModalTitle = forwardRef<HTMLHeadingElement, ModalTitleProps>(
  ({ className, children, ...props }, ref) => (
    <Dialog.Title
      className={cn(
        ['text-lg', 'font-semibold', 'leading-none', 'tracking-tight'],
        className,
      )}
      ref={ref}
      {...props}
    >
      {children}
    </Dialog.Title>
  ),
);
ModalTitle.displayName = 'ModalTitle';

export { ModalTitle, type ModalTitleProps };
